module.exports = require('./helpers/bundle-url').getBundleURL('7wWRQ') + "logo-dark.eefe0b7f.svg";